import React from "react";
import SecondaryCheckbox from "Components/common/SecondaryCheckbox";

const LiAccountListItem = (props = {}) => {
  const {
    id = "",
    label = "",
    isPremium = false,
    cbk = () => {},
    checked = false,
    disabled = false
  } = props || {};

  const handleCheckboxChange = val => {
    if (!disabled) {
      cbk(val, id, label);
    }
  };

  const inputObj = {
    label: "",
    id: `liAccount-${id}`,
    cbk: handleCheckboxChange,
    checked: checked,
    disabled: disabled
  };

  return (
    <div
      className={`inboxListItemWrapper ${checked ? "selected" : ""} ${
        disabled ? "disabled" : ""
      }`}
      onClick={e => {
        if (disabled || e.target.closest(".checkboxWrapper")) return;
        handleCheckboxChange(!checked);
      }}
    >
      <div className="checkboxWrapper">
        <SecondaryCheckbox {...inputObj} />
      </div>
      <div className="inboxDetails">
        <div className="inboxEmail">{label}</div>
        {isPremium && (
          <div className="inboxStats">
            <span className="statsBadge activeBadge">Sales Navigator</span>
          </div>
        )}
      </div>
    </div>
  );
};

export default LiAccountListItem;
